@if (cellMenuContextual) {
  <div [ngClass]="'contextmenu'" [ngStyle]="{'left.px': x, 'top.px': y, '--size': size ? size : '259px', '--overflowY': !size && lengthMenu >= 7 ? 'scroll' : 'hidden'}">
    @for (menu of menusOpciones; track menu.id) {
      <span #itemSpan style="height: 37px;" (mouseover)="over($event, menu)" (click)="copySelectedCellData(menu)" [class.disabled]="menu.disabled" [class.noVisible]="menu.disabled">
        <div class="item">
          <div class="menu-item">
            <igx-icon class="icon" [style.transform]="'rotate(' + menu.rotationAngle + 'deg)'">{{ menu.icono }} </igx-icon> {{ menu.descripcion | translate}}
          </div>
          @if (menu.subMenu) {
            <igx-icon class="icon">chevron_right</igx-icon>
          }
        </div>
        @if (menu.divisor) {
          <igx-divider></igx-divider>
        }
      </span>
    }
  </div>
}

<div [ngClass]="'contextsubmenu'" [ngStyle]="{'left.px': subX, 'top.px': subY}">
  @for (menu2 of subMenusOpciones; track menu2) {
    <span style="height: 37px;" (click)="copySelectedCellData(menu2)" [class.disabled]="menu2.disabled" [class.noVisible]="menu2.noVisible">
      <div class="subItem">
        <igx-icon class="icon" [style.transform]="'rotate(' + menu2.rotationAngle + 'deg)'">{{ menu2.icono }} </igx-icon> {{ menu2.descripcion | translate}}
      </div>
      @if (menu2.divisor) {
        <igx-divider></igx-divider>
      }
    </span>
  }
</div>
